// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MaintainanceContainer {
  max-width: 1400px;
  margin: 0 auto;

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, sans-serif;
  background-color: #f8fafc;
  min-height: 100vh;
}

/*  */

.Maintainance-header {
  position: relative;
  /* background: var(--land-gradient-purple); */
  background: linear-gradient(135deg, #8aaae5 50%, #cadcfc 100%);
  color: white;
  padding: 1rem 1rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
  border-radius: 0 0 0rem 0rem;
  box-shadow: var(--land-shadow-lg);
}

.Maintainance-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.Maintainance-animated-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: landFloat 6s ease-in-out infinite;
}

.Maintainance-shape-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.Maintainance-shape-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.Maintainance-shape-3 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 20%;
  animation-delay: 4s;
}

.Maintainance-shape-4 {
  width: 120px;
  height: 120px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

@keyframes landFloat {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

.Maintainance-header-content {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.Maintainance-title {
  /* font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem; */
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.Maintainance-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  font-weight: 300;
}

/*  */

.MaintainanceTableWrapper {
  overflow-x: auto;
}

/* .MaintainanceHeader {
  text-align: center;
  color: #000000;
} */

/* .MaintainanceTitle {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
} */

.MaintainanceIcon {
  font-size: 2.2rem;
}

.MaintainanceSubtitle {
  font-size: 1.1rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 300;
}

/* Controls Section */
.MaintainanceControls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  gap: 16px;
  flex-wrap: wrap;
}

.MaintainanceSearchWrapper {
  flex: 1 1;
  max-width: 400px;
}

.MaintainanceSearchInput {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background-color: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.MaintainanceSearchInput:focus {
  outline: none;
  border-color: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.MaintainanceAddButton {
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background: #598699;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.MaintainanceAddButton:hover {
  transform: translateY(-2px);
}

.MaintainanceButtonIcon {
  font-size: 1.2rem;
  font-weight: bold;
}

/* Form Overlay */
.MaintainanceFormOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  backdrop-filter: blur(4px);
}

.MaintainanceFormContainer {
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: MaintainanceSlideIn 0.3s ease-out;
}

@keyframes MaintainanceSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.MaintainanceFormHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 32px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 20px 20px 0 0;
}

.MaintainanceFormTitle {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.MaintainanceCloseButton {
  background: none;
  border: none;
  font-size: 2rem;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  transition: all 0.2s ease;
  line-height: 1;
}

.MaintainanceCloseButton:hover {
  background-color: #f1f5f9;
  color: #ef4444;
}

/* Form Styles */
.MaintainanceForm {
  padding: 32px;
}

.MaintainanceFormGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.MaintainanceFormGroup {
  display: flex;
  flex-direction: column;
}

.MaintainanceFormGroupFull {
  grid-column: 1 / -1;
}

.MaintainanceLabel {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.MaintainanceInput,
.MaintainanceSelect,
.MaintainanceTextarea {
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background-color: #fafafa;
}

.MaintainanceInput:focus,
.MaintainanceSelect:focus,
.MaintainanceTextarea:focus {
  outline: none;
  border-color: #667eea;
  background-color: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.MaintainanceTextarea {
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.MaintainanceFormActions {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.MaintainanceSaveButton {
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.MaintainanceSaveButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.MaintainanceCancelButton {
  background: #f8fafc;
  color: #64748b;
  border: 2px solid #e2e8f0;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.MaintainanceCancelButton:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}

/* Table Container */
.MaintainanceTableContainer {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.MaintainanceTableHeader {
  display: table-cell;
  padding: 16px 20px;
  text-align: left;
  font-weight: 700;
  color: #374151;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e5e7eb;
  vertical-align: middle;
  writing-mode: horizontal-tb;
}

.MaintainanceTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.MaintainanceTableHead {
  /* background: #f8fafc; */
  background: #f3f4f6;
}

.MaintainanceTableRow {
  display: table-row;
}

/* .MaintainanceTableRow:nth-child(even) {
  background-color: #f9fafb;
} */

.MaintainanceTableRow:hover {
  /* background-color: #f0f9ff; */
  background-color: #f9fafb;
}

.MaintainanceTableCell {
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
  display: table-cell;
}

.MaintainanceTableCellIndex {
  font-weight: 600;
  color: #6b7280;
  width: 60px;
}

.MaintainanceTableCellMachine {
  font-weight: 600;
  color: #1f2937;
}

.MaintainanceTableCellDescription {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.MaintainanceTableCellDate {
  color: #000000;
}

.MaintainanceTableCellCost {
  font-weight: 600;
  color: #059669;
  font-family: "Courier New", monospace;
  padding: 5px;
  background-color: #bbf0df;
  border-radius: 50px;
  border: 1px solid #059669;
}

.MaintainanceTableCellActions {
  width: 120px;
  display: flex;
  gap: 8px;
}

.MaintainanceServiceBadge {
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white; */
  background: #598699;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.MaintainanceEditButton,
.MaintainanceDeleteButton {
  background: none;
  /* border: none; */
  stroke-width: 2;
  border: 1px solid #e5e7eb;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.MaintainanceEditButton {
  background: rgba(59, 130, 246, 0.1);
}
.MaintainanceEditButton:hover {
  background-color: #dbeafe;
  border-color: #3b82f6;
  /* transform: scale(1.1); */
}

.MaintainanceEditButton svg {
  color: #3b82f6;
  stroke-width: 2;
}

.MaintainanceDeleteButton {
  background: rgba(239, 68, 68, 0.1);
}
.MaintainanceDeleteButton:hover {
  background-color: #fee2e2;
  border-color: #ef4444;
  /* transform: scale(1.1); */
}

.MaintainanceDeleteButton svg {
  color: #ef4444;
  stroke-width: 2;
}

.MaintainanceTableCellEmpty {
  text-align: center;
  padding: 48px 20px;
}

.MaintainanceEmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: #6b7280;
}

.MaintainanceEmptyIcon {
  font-size: 3rem;
  opacity: 0.5;
}

.MaintainanceEmptyState p {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.MaintainanceEmptySubtext {
  font-size: 0.9rem !important;
  font-weight: 400 !important;
  opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 768px) {
  .MaintainanceContainer {
    padding: 16px;
  }

  .MaintainanceTitle {
    font-size: 2rem;
  }

  .MaintainanceControls {
    flex-direction: column;
    align-items: stretch;
  }

  .MaintainanceSearchWrapper {
    max-width: none;
  }

  .MaintainanceFormGrid {
    grid-template-columns: 1fr;
  }

  .MaintainanceForm {
    padding: 24px;
  }

  .MaintainanceFormActions {
    flex-direction: column;
  }

  .MaintainanceTableHeader,
  .MaintainanceTableTitle {
    padding: 16px 20px;
  }

  .MaintainanceTable {
    min-width: 800px;
  }

  .MaintainanceTableWrapper {
    overflow-x: auto;
  }

  .MaintainanceTableCell {
    padding: 12px 16px;
  }

  .MaintainanceTableCellDescription {
    max-width: 150px;
  }
}

@media (max-width: 480px) {
  .MaintainanceTitle {
    font-size: 1.8rem;
    flex-direction: column;
    gap: 8px;
  }

  .MaintainanceFormOverlay {
    padding: 10px;
  }

  .MaintainanceFormContainer {
    border-radius: 16px;
  }

  .MaintainanceFormHeader {
    padding: 20px 24px;
    border-radius: 16px 16px 0 0;
  }

  .MaintainanceForm {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Machine/Maintainance.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;;EAEd;iCAC+B;EAC/B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,KAAK;;AAEL;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,8DAA8D;EAC9D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;;IAEE,uCAAuC;EACzC;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;0BAEwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,KAAK;;AAEL;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;;;;;;;;GAQG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;iBACe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".MaintainanceContainer {\n  max-width: 1400px;\n  margin: 0 auto;\n\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n    Ubuntu, Cantarell, sans-serif;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n/*  */\n\n.Maintainance-header {\n  position: relative;\n  /* background: var(--land-gradient-purple); */\n  background: linear-gradient(135deg, #8aaae5 50%, #cadcfc 100%);\n  color: white;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  border-radius: 0 0 0rem 0rem;\n  box-shadow: var(--land-shadow-lg);\n}\n\n.Maintainance-header-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.Maintainance-animated-shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  animation: landFloat 6s ease-in-out infinite;\n}\n\n.Maintainance-shape-1 {\n  width: 100px;\n  height: 100px;\n  top: 20%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.Maintainance-shape-2 {\n  width: 150px;\n  height: 150px;\n  top: 60%;\n  right: 15%;\n  animation-delay: 2s;\n}\n\n.Maintainance-shape-3 {\n  width: 80px;\n  height: 80px;\n  bottom: 30%;\n  left: 20%;\n  animation-delay: 4s;\n}\n\n.Maintainance-shape-4 {\n  width: 120px;\n  height: 120px;\n  top: 10%;\n  right: 30%;\n  animation-delay: 1s;\n}\n\n@keyframes landFloat {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(180deg);\n  }\n}\n\n.Maintainance-header-content {\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.Maintainance-title {\n  /* font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem; */\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.Maintainance-subtitle {\n  font-size: 1.125rem;\n  opacity: 0.9;\n  font-weight: 300;\n}\n\n/*  */\n\n.MaintainanceTableWrapper {\n  overflow-x: auto;\n}\n\n/* .MaintainanceHeader {\n  text-align: center;\n  color: #000000;\n} */\n\n/* .MaintainanceTitle {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n} */\n\n.MaintainanceIcon {\n  font-size: 2.2rem;\n}\n\n.MaintainanceSubtitle {\n  font-size: 1.1rem;\n  margin: 0;\n  opacity: 0.9;\n  font-weight: 300;\n}\n\n/* Controls Section */\n.MaintainanceControls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.MaintainanceSearchWrapper {\n  flex: 1;\n  max-width: 400px;\n}\n\n.MaintainanceSearchInput {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background-color: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.MaintainanceSearchInput:focus {\n  outline: none;\n  border-color: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.MaintainanceAddButton {\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background: #598699;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n}\n\n.MaintainanceAddButton:hover {\n  transform: translateY(-2px);\n}\n\n.MaintainanceButtonIcon {\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n/* Form Overlay */\n.MaintainanceFormOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  backdrop-filter: blur(4px);\n}\n\n.MaintainanceFormContainer {\n  background: white;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: MaintainanceSlideIn 0.3s ease-out;\n}\n\n@keyframes MaintainanceSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.MaintainanceFormHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 32px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 20px 20px 0 0;\n}\n\n.MaintainanceFormTitle {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.MaintainanceCloseButton {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  line-height: 1;\n}\n\n.MaintainanceCloseButton:hover {\n  background-color: #f1f5f9;\n  color: #ef4444;\n}\n\n/* Form Styles */\n.MaintainanceForm {\n  padding: 32px;\n}\n\n.MaintainanceFormGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.MaintainanceFormGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.MaintainanceFormGroupFull {\n  grid-column: 1 / -1;\n}\n\n.MaintainanceLabel {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n  font-size: 0.95rem;\n}\n\n.MaintainanceInput,\n.MaintainanceSelect,\n.MaintainanceTextarea {\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background-color: #fafafa;\n}\n\n.MaintainanceInput:focus,\n.MaintainanceSelect:focus,\n.MaintainanceTextarea:focus {\n  outline: none;\n  border-color: #667eea;\n  background-color: white;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.MaintainanceTextarea {\n  resize: vertical;\n  min-height: 100px;\n  font-family: inherit;\n}\n\n.MaintainanceFormActions {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n  padding-top: 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.MaintainanceSaveButton {\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.MaintainanceSaveButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.MaintainanceCancelButton {\n  background: #f8fafc;\n  color: #64748b;\n  border: 2px solid #e2e8f0;\n  padding: 12px 24px;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.MaintainanceCancelButton:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n/* Table Container */\n.MaintainanceTableContainer {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n}\n\n.MaintainanceTableHeader {\n  display: table-cell;\n  padding: 16px 20px;\n  text-align: left;\n  font-weight: 700;\n  color: #374151;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #e5e7eb;\n  vertical-align: middle;\n  writing-mode: horizontal-tb;\n}\n\n.MaintainanceTable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.MaintainanceTableHead {\n  /* background: #f8fafc; */\n  background: #f3f4f6;\n}\n\n.MaintainanceTableRow {\n  display: table-row;\n}\n\n/* .MaintainanceTableRow:nth-child(even) {\n  background-color: #f9fafb;\n} */\n\n.MaintainanceTableRow:hover {\n  /* background-color: #f0f9ff; */\n  background-color: #f9fafb;\n}\n\n.MaintainanceTableCell {\n  padding: 16px 20px;\n  border-bottom: 1px solid #f3f4f6;\n  vertical-align: middle;\n  display: table-cell;\n}\n\n.MaintainanceTableCellIndex {\n  font-weight: 600;\n  color: #6b7280;\n  width: 60px;\n}\n\n.MaintainanceTableCellMachine {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.MaintainanceTableCellDescription {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.MaintainanceTableCellDate {\n  color: #000000;\n}\n\n.MaintainanceTableCellCost {\n  font-weight: 600;\n  color: #059669;\n  font-family: \"Courier New\", monospace;\n  padding: 5px;\n  background-color: #bbf0df;\n  border-radius: 50px;\n  border: 1px solid #059669;\n}\n\n.MaintainanceTableCellActions {\n  width: 120px;\n  display: flex;\n  gap: 8px;\n}\n\n.MaintainanceServiceBadge {\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white; */\n  background: #598699;\n  color: #ffffff;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.MaintainanceEditButton,\n.MaintainanceDeleteButton {\n  background: none;\n  /* border: none; */\n  stroke-width: 2;\n  border: 1px solid #e5e7eb;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.MaintainanceEditButton {\n  background: rgba(59, 130, 246, 0.1);\n}\n.MaintainanceEditButton:hover {\n  background-color: #dbeafe;\n  border-color: #3b82f6;\n  /* transform: scale(1.1); */\n}\n\n.MaintainanceEditButton svg {\n  color: #3b82f6;\n  stroke-width: 2;\n}\n\n.MaintainanceDeleteButton {\n  background: rgba(239, 68, 68, 0.1);\n}\n.MaintainanceDeleteButton:hover {\n  background-color: #fee2e2;\n  border-color: #ef4444;\n  /* transform: scale(1.1); */\n}\n\n.MaintainanceDeleteButton svg {\n  color: #ef4444;\n  stroke-width: 2;\n}\n\n.MaintainanceTableCellEmpty {\n  text-align: center;\n  padding: 48px 20px;\n}\n\n.MaintainanceEmptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  color: #6b7280;\n}\n\n.MaintainanceEmptyIcon {\n  font-size: 3rem;\n  opacity: 0.5;\n}\n\n.MaintainanceEmptyState p {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.MaintainanceEmptySubtext {\n  font-size: 0.9rem !important;\n  font-weight: 400 !important;\n  opacity: 0.7;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .MaintainanceContainer {\n    padding: 16px;\n  }\n\n  .MaintainanceTitle {\n    font-size: 2rem;\n  }\n\n  .MaintainanceControls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .MaintainanceSearchWrapper {\n    max-width: none;\n  }\n\n  .MaintainanceFormGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .MaintainanceForm {\n    padding: 24px;\n  }\n\n  .MaintainanceFormActions {\n    flex-direction: column;\n  }\n\n  .MaintainanceTableHeader,\n  .MaintainanceTableTitle {\n    padding: 16px 20px;\n  }\n\n  .MaintainanceTable {\n    min-width: 800px;\n  }\n\n  .MaintainanceTableWrapper {\n    overflow-x: auto;\n  }\n\n  .MaintainanceTableCell {\n    padding: 12px 16px;\n  }\n\n  .MaintainanceTableCellDescription {\n    max-width: 150px;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaintainanceTitle {\n    font-size: 1.8rem;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .MaintainanceFormOverlay {\n    padding: 10px;\n  }\n\n  .MaintainanceFormContainer {\n    border-radius: 16px;\n  }\n\n  .MaintainanceFormHeader {\n    padding: 20px 24px;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .MaintainanceForm {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
